import { render, staticRenderFns } from "./vcSelectDefinition.vue?vue&type=template&id=5c05b088&"
import script from "./vcSelectDefinition.vue?vue&type=script&lang=js&"
export * from "./vcSelectDefinition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports